import grid from './grid/grid';
import getTypography from './typography/typography';
import elevations from './elevations/elevations';
import colors from './colors/colors';
import breakpoints from './breakpoints/breakpoints';
export const TucarTheme = {
    name: 'light-theme',
    colors: Object.assign({}, colors),
    breakpoints,
    grid,
    typography: getTypography(),
    elevations,
};
//# sourceMappingURL=theme.js.map